import {createDisplayImageField} from '../shared/createDisplayImageField';
import {
  BACKGROUND_IMAGE_FIELD,
  BACKGROUND_MENU_FIELD,
  createImageUploadSectionConfig
} from '../shared/displayImageFieldPresets';

export const BACKGAMMON_BACKGROUND_IMAGE_FIELDS = [
  BACKGROUND_MENU_FIELD,
  BACKGROUND_IMAGE_FIELD,
  createDisplayImageField('backgroundVS', 'Background VS'),
  createDisplayImageField('backgroundWaiting', 'Background Waiting'),
  createDisplayImageField('backgroundExit', 'Background Exit')
];

export const BACKGAMMON_BACKGROUND_SECTION_CONFIG =
  createImageUploadSectionConfig({
    testId: 'backgammon-background-images-section',
    downloadButtonIcon: 'trailing'
  });
